import React, { useState } from 'react';
import DataEntry from '../add_user';

const isEditting = true;

export default function DetailsPage(props){
    const [userDetails] = useState(props);
    console.log("🚀 ~ file: index.jsx ~ line 8 ~ DetailsPage ~ customerDetails", userDetails)
    console.log('details and update');
    return(
        <div>
            <DataEntry 
                userDetails={userDetails.location.state} 
                isEditting={isEditting}
            />
        </div>
    );
}